var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('r-table',_vm._b({ref:"table",attrs:{"loading-text":"Cargando pagos del proveedor...","no-data-text":"Sin pagos del proveedor.","no-actions":"","no-search":"","no-remove":""},on:{"detail":_vm.submitShow}},'r-table',_vm.tableProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }